import React from 'react';
import { Modal } from 'react-bootstrap';
import { closeButton } from '../../assets/images/images';

interface ZeroCandidatesModalProps {
    show: boolean;
    onHide: () => void;
}

const ZeroCandidatesModal: React.FC<ZeroCandidatesModalProps> = ({ show, onHide }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            dialogClassName="modal-600 modal-dialog-centered"
            className="disclaimer-modal zero-candidates-modal"
            backdrop="static"
            keyboard={false}
        >
            <img
                src={closeButton}
                alt="Close"
                className="cross-btn"
                onClick={onHide}
            />
            <Modal.Body>
                <div className="disclaimer-header" style={{ marginBottom: '20px' }}>
                    <h4 className="modal-head modal-head-medium" style={{ color: '#FF4D4D', fontWeight: 'bold' }}>
                        Too Strict Filtering Detected!!!
                    </h4>
                </div>

                <div className="disclaimer-content">
                    <ul className="demo-limitations" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                        <li style={{ marginBottom: '15px', fontSize: '16px', lineHeight: '1.5' }}>
                            <strong>Make the Must-Haves</strong> — include only the truly essential requirements, since these act as absolute filters.
                        </li>
                        <li style={{ fontSize: '16px', lineHeight: '1.5' }}>
                            <strong>Apply Won’t-Haves</strong> — if a candidate matches any Won’t-Have, they should be automatically removed.
                        </li>
                    </ul>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ZeroCandidatesModal;
